// extracted by mini-css-extract-plugin
export var createdDate = "_kv-1";
export var divider = "_kv-2";
export var headerDivider = "_kv-3";
export var messagesCard = "_kv-0";
export var messagesContainer = "_kv-6";
export var messagesContainerWrapper = "_kv-4";
export var showLeftPanelButton = "_kv-8";
export var topButtons = "_kv-7";
export var withPadding = "_kv-5";